import React from 'react';
import {Link} from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faInstagram, faFacebookF, faTwitter} from '@fortawesome/free-brands-svg-icons';

export default function AdminFooter() {
    return(
    <section className='admin-footer'>
        <div className='footer'>
        <div className='container'>
            <div className='row'>
                <div className='col-md-8 col-12'>
                    <h1>SIGN UP FOR THE PHOTO L.A. NEWSLETTER</h1>
                    <div className='footer-nav'>
                        <ul>
                            <li>
                            <Link to="/">About</Link> | 
                            </li>
                            <li>
                            <Link to="/">Partner</Link> | 
                            </li>
                            <li>
                            <Link to="/">Contact Us</Link> | 
                            </li>
                            <li>
                            <Link to="/">Privacy Policy</Link> | 
                            </li>
                            <li>
                            <Link to="/">Cookie Policy</Link>
                            </li>
                        </ul>
                    </div>
                    <div className='follow-us'>
                        <h2>Follow Us:</h2>
                    <ul>
                    <li>
                    <Link to="/"> <FontAwesomeIcon icon={faInstagram} /></Link>
                    </li>
                    <li>
                    <Link to="/"><FontAwesomeIcon icon={faFacebookF} /></Link>
                    </li>
                    <li>
                    <Link to="/"><FontAwesomeIcon icon={faTwitter} /></Link>
                    </li>
                </ul>
                    </div>
                </div>
                <div className='col-md-4 col-12'>
                    <div className='newsletter'>
                    Join Our Newsletter
                    </div>
                </div>
            </div>
        </div>
        </div>
       
    </section>
    )
}